module.exports = __webpack_public_path__ + "img/contact_sync.fc21bf5f.jpg";